export default __webpack_public_path__ + "static/media/Search.fa37a7d8.svg";